<template>
    <div class="wrapper">
        <Header />
        <router-view :key="key" />
        <Footer />
    </div>
</template>
<script>
import { Header, Footer } from './components'
export default {
    name: 'Layout',
    components: {
        Header,
        Footer
    },
    data() {
        return {

        }
    },
    computed: {
        key() {
            return this.$route.path
        }
    },
    methods: {

    }
}
</script>
<style  scoped>

</style>



// WEBPACK FOOTER //
// src/layout/index.vue